module.exports = __webpack_public_path__ + "static/media/Test21.6766c7c6.bmp";